import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { of } from "rxjs";
import { map } from "rxjs/operators";
import { alertListColumns } from "src/app/feature/alert/model/alert.model";
import { endpoints } from "src/environments/environment";
import { Utility } from "../../utility/utility";

@Injectable({
    providedIn: "root",
})
export class NotificationsService {
    constructor(private http: HttpClient) { }

    registerDevice(tokenDevice: string) {
        const customerId = Utility.getCustomerId();
        const contactId = Utility.getContractId();
        return this.http.post(endpoints.notifications_device_add, { tokenDevice, customerId, contactId });
    }

    getUnreadNotifications() {
        const contactId = Utility.getContractId();
        return this.http.post(endpoints.notifications_unread_count, { contactId }).pipe(map((res: any) => res?.count || 0));
    }

    getNotifications(page = "1", pageSize = "10") {
        const contactId = Utility.getContractId();
        return this.http.post(endpoints.notifications_list + "?page="+page + "&pageSize=" + pageSize, { contactId });
    }

    setNotificationReadStatus(idNotification: string) {
        return this.http.put(endpoints.notifications_read_status, {
            idNotification
        });
    }

    getListColumns() {
        return of(alertListColumns);
    }


}
